import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Flex } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import RichTextEditor from '../../../../../components/RichTextEditor';
import { EmailAutomationTriggers } from '../../../../../constants/emailAutomations';
import { createToast } from '../../../../../redux/modules/app';
import {
  selectCurrentSignature,
  selectDefaultSignature,
  setCurrentSignature
} from '../../../../../redux/modules/emails';
import EmailTemplateDropdown from '../../EmailTemplateDropdown';
import PersonalizeDropdown from '../../PersonalizeDropdown';

const EmailSignature = ({
  signatureContainerId, onChange, value, automationTrigger, disableTemplateCreation, ...rest
}) => {
  const dispatch = useDispatch();
  const defaultSignature = useSelector(selectDefaultSignature);
  const currentSignature = useSelector(selectCurrentSignature);
  const editorRef = useRef();

  const { templateInfo: { html: defaultSignatureHtml } } = defaultSignature || { templateInfo: {} };

  useEffect(() => {
    if (!currentSignature && !onChange) {
      dispatch(setCurrentSignature(defaultSignatureHtml));
    }

    if (onChange && currentSignature) {
      onChange(currentSignature);
    }
  }, [currentSignature, defaultSignatureHtml]);

  const handleChange = val => {
    if (onChange) {
      onChange(val);
    }

    dispatch(setCurrentSignature(val));
  };

  return (
    <Box p={4} {...rest}>
      <Flex alignItems="center" mb={3}>
        <Box fontWeight="semibold" mr={4} textAlign="left">Signature: </Box>
        <EmailTemplateDropdown
          disableTemplateCreation={disableTemplateCreation}
          templateWord="Signature"
          type="signature"
        />
        <PersonalizeDropdown
          automationTrigger={automationTrigger}
          px={2}
          onClick={val => {
            navigator.clipboard.writeText(val);

            dispatch(createToast({
              title: 'Token Copied',
              type: 'info',
              duration: 3000
            }));
          }}
        />
      </Flex>
      <Flex className="reportsRow text-left background-light-grey p-0 pt-4">
        <Box width="100%" xs="12">
          <RichTextEditor
            showToolbar
            defaultTemplate={defaultSignature}
            id={signatureContainerId}
            innerRef={editorRef}
            value={value !== undefined ? value : currentSignature || defaultSignatureHtml}
            onChange={handleChange}
          />
        </Box>
      </Flex>
    </Box>
  );
};

EmailSignature.propTypes = {
  signatureContainerId: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.string,
  automationTrigger: PropTypes.oneOf(Object.values(EmailAutomationTriggers)),
  disableTemplateCreation: PropTypes.bool
};

export default EmailSignature;
